export default "__VITE_ASSET__BiSKSwzL__"